
//入库下单快捷导航dom监控扩展类
class QuickNav {
  private config: any = {};
  constructor(config: { selector: string, extFieldName?: string }) {
    this.config = config;
  }
  getExt() {
    let el = document.querySelector(this.config.selector);
    let checkedEl = el?.querySelector('.winitd-checkbox-checked')?.querySelector('.winitd-checkbox-input');
    let quickCheckedLabel = checkedEl?.getAttribute('data-monitor-fieldlabel');
    let quickCheckedKey = checkedEl?.getAttribute('data-monitor-fieldkey');
    if (!quickCheckedLabel) return null;
    return {
      [this.config.extFieldName || 'quickCheckedLabel']: quickCheckedLabel,
      'quickCheckedKey': quickCheckedKey,
      'quickCheckedValue': checkedEl?.getAttribute('value'),
    };
  }
  private createObserver() {
  }
  start() {

  };
  stop() {
  }
}

export default QuickNav;
